import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { BlockedPhoneNumberDetailSaveModel } from '../models/blocked-phone-number-detail-save.model';

export const addBlockedPhoneNumber = createAction('[Add Blocked Phone Number] Add Blocked Phone Number');

export const createBlockedPhoneNumber = createAction(
   '[Create Blocked Phone Number] Create Blocked Phone Number',
   props<{ blockedPhoneNumber: BlockedPhoneNumberDetailSaveModel }>()
);

export const createBlockedPhoneNumberAndAddAnother = createAction(
   '[Create Blocked Phone Number] Create Blocked Phone Number and Add Another',
   props<{ blockedPhoneNumber: BlockedPhoneNumberDetailSaveModel }>()
);

export const createBlockedPhoneNumberSuccess = createAction(
   '[Add Blocked Phone Number] Create Blocked Phone Number Success',
   props<{ blockedPhoneNumberId: number; phoneNumber: string | null }>()
);

export const createBlockedPhoneNumberAndAddAnotherSuccess = createAction(
   '[Add Blocked Phone Number] Create Blocked Phone Number and Add Another Success',
   props<{ blockedPhoneNumberId: number; phoneNumber: string | null }>()
);

export const createBlockedPhoneNumberFailure = createAction(
   '[API] Create Blocked Phone Number Failure',
   props<SingleGraphError>()
);

export const createBlockedPhoneNumberAndAddAnotherFailure = createAction(
   '[API] Create Blocked Phone Number and Add Another Failure',
   props<SingleGraphError>()
);
